import React from 'react'
import { Row } from './layout'
import styled, { css } from 'styled-components'
import Svg from './svg'
import { Link } from 'gatsby'

export default function NavigationBar() {
  return (
    <Row alignment="center" innerStyle={containerStyle}>
      <Link to="/">
        <Logo name="logo" />
      </Link>
    </Row>
  )
}

const containerStyle = css`
  padding: 24px 36px;
`

const Logo = styled(Svg)`
  height: 42px;
`
